export const isDebug = (): boolean => {
	try {
		// eslint-disable-next-line no-eval
		return eval("__DEV__")
	} catch (err) {
		return false
	}
}
